import { Component } from "preact";
import { route } from "preact-router";
import style from "./style.scss";
class NotFound extends Component {
	pageKey = "Page Not Found";

	navigateToLogin() {
		route(loginRoute.path);
	}
	render() {
		return (
			<div className={style.container}>
				<div>
					<div>
						<img
							className={style.img}
							src="https://www.indiabonds.com/static/customer/home_page/images/404.png"
							alt="Page Not Found"
						/>
					</div>
					<div className={style.btn}>
						<button
							class="primary-btn"
							type="button"
							onClick={() => route("/")}
						>
							Go to Homepage
						</button>
					</div>
				</div>
			</div>
		);
	}
}

export default NotFound;
